<div class="flex flex-col border border-body rounded relative">
  <div
    class="flex justify-between items-end p-12 cursor-pointer"
    (click)="redirectToProfile()"
  >
    <tdv-avatar
      data-cy="sidebar-avatar"
      class="mr-20 mb-2"
      [config]="authUserStateS.avatarSgnl()"
      [size]="32"
    ></tdv-avatar>
    <div class="flex flex-col flex-grow min-w-128">
      <p class="text-10 pb-9 font-bold uppercase">
        {{ 'auth-menu.title' | transloco }}
      </p>
      <p class="text-13" data-cy="sidebar-user-name">
        <ng-container
          *ngIf="
            authUserSgnl()?.is_clinic_account && authUserSgnl()?.user_profile;
            else notClinicAccountTmpl
          "
        >
          {{ authUserSgnl()?.user_profile | tdvAuthProfileUserName }}
        </ng-container>

        <ng-template #notClinicAccountTmpl>
          {{ authUserSgnl()?.first_name || '' }}
          {{ authUserSgnl()?.last_name || '' }}
        </ng-template>
      </p>
      @if (isLocalDev) {
        <tdv-theme-switcher
          class="mt-8"
          (click)="$event.preventDefault(); $event.stopPropagation()"
        ></tdv-theme-switcher>
      }
    </div>
  </div>
  <div class="px-12 pt-8 pb-6">
    <hr class="border-1 border-line" />
  </div>
  <div class="flex flex-col pb-12">
    <div
      data-cy="manage-account"
      class="flex items-center px-15 py-3 hover:bg-gray-300-o-06 cursor-pointer"
      (click)="redirectToProfile()"
    >
      <tdv-icon [name]="'user-edit'" class="w-24 h-24"></tdv-icon>
      <p class="text-11 pl-25 font-medium select-none">
        {{ 'auth-menu.manage-acc' | transloco }}
      </p>
    </div>
    <div
      *ngIf="subscriptionsS.isTrainingResourcesAvailableSgnl()"
      class="flex items-center px-15 py-3 hover:bg-gray-300-o-06 cursor-pointer"
      (click)="redirectToTrainingResources()"
    >
      <tdv-icon-svg-learning class="w-24 h-24"></tdv-icon-svg-learning>
      <p class="text-11 pl-25 font-medium select-none">
        {{ 'Resources' | transloco }}
      </p>
    </div>
    <div
      *ngIf="authUserStateS.isClinicSgnl()"
      class="flex items-center px-15 py-3 hover:bg-gray-300-o-06 cursor-pointer"
      (click)="onSwitchProfile()"
    >
      <tdv-icon-svg-switch class="w-24 h-24"></tdv-icon-svg-switch>
      <p class="text-11 pl-25 font-medium select-none">
        {{ 'Switch Profile' | transloco }}
      </p>
    </div>
    <div
      data-cy="logout"
      class="flex items-center px-15 py-3 hover:bg-gray-300-o-06 cursor-pointer"
      (click)="logOut()"
    >
      <tdv-icon [name]="'logout'" class="w-24 h-24 select-none"></tdv-icon>
      <p class="text-11 pl-25 font-medium select-none">
        {{ 'btn.log-out' | transloco }}
      </p>
    </div>
  </div>
</div>
